"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

var _index = require("../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Tracks analytics events to Google Analytics service from a React JS app
 */
var GoogleAnalyticsClassicTrackerService = /*#__PURE__*/function () {
  /**
   * Initializes tracker
   *
   * @param {String} trackingId
   */
  function GoogleAnalyticsClassicTrackerService(trackingId) {
    _classCallCheck(this, GoogleAnalyticsClassicTrackerService);

    var _getConfig = (0, _index.getConfig)(),
        GOOGLE_ANALYTICS_DEBUG = _getConfig.GOOGLE_ANALYTICS_DEBUG;

    _reactGa["default"].initialize(trackingId, {
      debug: GOOGLE_ANALYTICS_DEBUG,
      titleCase: false,
      gaOptions: {}
    });

    this.customDimensions = {}; // Initialize the setup
  }
  /**
   * Updates event context
   *
   * @param {Object} data
   */


  _createClass(GoogleAnalyticsClassicTrackerService, [{
    key: "set",
    value: function set(data) {
      this.customDimensions = _objectSpread(_objectSpread({}, this.customDimensions), data);
    }
    /**
     * Returns cached version of custom dimensions
     *
     * @return {{}|*}
     */

  }, {
    key: "getCustomDimensions",
    value: function getCustomDimensions() {
      return this.customDimensions;
    }
    /**
     * Tracks event
     *
     * @param {Object} event
     */

  }, {
    key: "event",
    value: function event(_event) {
      _reactGa["default"].event(_objectSpread({
        category: _event.category,
        action: _event.action,
        label: _event.label
      }, this.customDimensions));
    }
    /**
     * Tracks screen (page) view
     *
     * @param {String} location
     */

  }, {
    key: "screen",
    value: function screen(location) {
      // removing # just in case we will move away from hash router or consider server-side rendering
      // in that case all tracked URLs will remain the same
      var path = location.hash.substr(1);

      _reactGa["default"].set(_objectSpread({
        page: path
      }, this.customDimensions));

      _reactGa["default"].pageview(path);
    }
  }]);

  return GoogleAnalyticsClassicTrackerService;
}();

exports["default"] = GoogleAnalyticsClassicTrackerService;